import { AlignSettings as KendoAlignSettings, Orientation as KendoOrientation } from "@progress/kendo-angular-layout";

export interface AlignSettings extends KendoAlignSettings {}

export type Orientation = KendoOrientation;